
import {Injectable, OnInit} from '@angular/core';
import { OAuthService, JwksValidationHandler } from 'angular-oauth2-oidc';
import { authImplicitFlowConfig } from '../helpers/auth.config';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private inicializado: boolean;
  constructor(private oauthService: OAuthService) {
    this.inicializado = false;
    this.configureOauthApi();
  }

  private configureOauthApi() {
      this.oauthService.configure(authImplicitFlowConfig);
      this.oauthService.setupAutomaticSilentRefresh();
      this.oauthService.tokenValidationHandler = new JwksValidationHandler();
      //this.oauthService.loadDiscoveryDocumentAndTryLogin();
      this.inicializado = true;
      this.oauthService.setStorage(localStorage);
  }

  getAccessToken(): string {
    return this.oauthService.getAccessToken();
  }

  setAccessToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  loadUserDetails() {
    return this.oauthService.loadUserProfile();
  }

  get access_token_expiration() {
    return this.oauthService.getAccessTokenExpiration();
  }

  getFullName() {
    return this.getClaimEntry('nombre_completo');
  }

  firstName() {
    return this.getClaimEntry('first_name');
  }

  isLoggedIn() {
    if (this.oauthService.getAccessToken() === null) {
      return false;
    }
    if(!this.oauthService.hasValidAccessToken()){
      return false;
    }
    console.log("access_token_expiration="+this.oauthService.getAccessTokenExpiration());
    return true;
  }


  public loginWithCredentials(username: string, password: string){
    return this.oauthService
      .fetchTokenUsingPasswordFlow(
        username,
        password
      );
  }


  public logout() {
    this.oauthService.logOut();

  }

  private getClaimEntry(entry) {
    var claims = this.oauthService.getIdentityClaims();

    if (!claims) {
      console.log('no tiene los claims');
      this.oauthService.loadUserProfile().then(() => {
        console.log('successfully loadUserProfile');
        claims = this.oauthService.getIdentityClaims();
        if (!claims) {
          return claims[entry];
        }
      })
      .catch(err => {
        console.error('error loadUserProfile');
      });
    } else {
      console.log('si tiene los claims entry '+entry);
      return claims[entry];
    }
  }

}
